import styled from 'styled-components';
import { Heading3Text } from '../../../components/Texts';
import TextInput from '../../../components/Inputs/Text';
import { Controller, useForm } from 'react-hook-form';
import Button from '../../../components/Button';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useGetMetricsMutation } from '../../../redux/api/authorized/metrics';

const Container = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  gap: 20px;
`;

const schema = yup
  .object({
    startDate: yup.string().required('startDate is required'),
    endDate: yup.string().required('endDate is required'),
  })
  .required();

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Report = () => {
  const [metrics, setMetrics] = useState(null);
  const [getMetrics] = useGetMetricsMutation();

  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 7);

  const {
    control,
    handleSubmit,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      startDate: oneWeekAgo.toISOString().split('T')[0],
      endDate: today.toISOString().split('T')[0],
    },
  });

  const handleFormSubmit = async (data) => {
    const response = await getMetrics({
      startDate: data.startDate,
      endDate: data.endDate,
    });
    setMetrics(response.data);
  };

  return (
    <Container>
      <Heading3Text>Metrics by date</Heading3Text>
      <InputContainer>
        <Controller
          name='startDate'
          control={control}
          render={({ field }) => (
            <TextInput
              label='Start Date'
              type='text'
              placeholder='YYYY-MM-DD'
              error={errors?.startDate?.message}
              {...field}
            />
          )}
        />
        <Controller
          name='endDate'
          control={control}
          render={({ field }) => (
            <TextInput
              label='End Date'
              type='text'
              placeholder='YYYY-MM-DD'
              error={errors?.endDate?.message}
              {...field}
            />
          )}
        />
      </InputContainer>
      <Button
        onClick={handleSubmit(handleFormSubmit)}
        loading={isSubmitting}
        disabled={!isValid || isSubmitting}
      >
        Submit Form
      </Button>
      {metrics && (
        <>
          <Heading3Text>Metrics</Heading3Text>
          <InputContainer>
            <TextInput
              label='New users'
              type='text'
              value={metrics.users}
              disabled
            />
            <TextInput
              label='Giveaway subscribers'
              type='text'
              value={metrics.giveawaySubscribers}
              disabled
            />
          </InputContainer>
          <InputContainer>
            <TextInput
              label='App downloads'
              type='text'
              value={metrics.appDownloads}
              disabled
            />
            <TextInput
              label='Gifts'
              type='text'
              value={metrics.gifts}
              disabled
            />
          </InputContainer>
          <InputContainer>
            <TextInput
              label='Gifts volume'
              type='text'
              value={metrics.giftsVolume}
              disabled
            />
            <TextInput
              label='Swaps'
              type='text'
              value={metrics.swaps}
              disabled
            />
          </InputContainer>
          <TextInput
            label='Swaps volume'
            type='text'
            value={metrics.swapsVolume}
            disabled
          />
        </>
      )}
    </Container>
  );
};

export default Report;
